let likedCount = 0

export function incrementLikeCount() {
    likedCount++
    updateExternalUI()
}

export function decrementLikeCount() {
    likedCount = Math.max(0, likedCount - 1)
    updateExternalUI()
}

function updateExternalUI() {
    const parent = document.getElementById('myhie-likes')
    if (!parent) return

    const likesInactiveIcon = parent.querySelector('.btn--myhie__inactive')
    const likesActiveIcon = parent.querySelector('.btn--myhie__active')

    if (likedCount > 0) {
        parent.classList.add('hasLikes')
        likesInactiveIcon.classList.add('hidden')
        likesActiveIcon.classList.remove('hidden')
    } else {
        parent.classList.remove('hasLikes')
        likesInactiveIcon.classList.remove('hidden')
        likesActiveIcon.classList.add('hidden')
    }
}